import { render, staticRenderFns } from "./addGp.vue?vue&type=template&id=7f0a206a&scoped=true&"
import script from "./addGp.vue?vue&type=script&lang=js&"
export * from "./addGp.vue?vue&type=script&lang=js&"
import style0 from "./addGp.vue?vue&type=style&index=0&id=7f0a206a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a206a",
  null
  
)

export default component.exports